import { useEffect, useState } from 'react'

import { AddressInfo } from './types'

type UseAddressProps = {
  selected: AddressInfo | null
  noAddress: boolean
  onChange: (value: AddressInfo) => void
}

export function useAddress({ selected, noAddress, onChange }: UseAddressProps) {
  const [query, setQuery] = useState('')

  useEffect(() => {
    if (selected?.description) {
      setQuery(selected?.description)
    }
  }, [selected?.description])

  useEffect(() => {
    if (noAddress) {
      onChange({ description: 'N/A', place_id: '' })
      setQuery('N/A')
    } else {
      onChange({ description: '', place_id: '' })
      setQuery('')
    }
  }, [noAddress, onChange])

  return { query, setQuery }
}
